export default "__VITE_ASSET__DRZsBwm5__"